import { useEffect, useState } from "react";
import Button from "../../../components/Button";
import AnimatedTitle from "../../../components/AnimatedTitle";
import AnimatedBox from "../../../components/AnimatedBox";

const data = [
  {
    img: "/store.png",
    text: "APP STORE",
  },
  {
    img: "/play.png",
    text: "GOOGLE PLAY",
  },
];

function BuildingSection() {
  const [isXsm, setIsXsm] = useState(
    window.innerWidth >= 410 && window.innerWidth < 640
  );
  const [isSm, setIsSm] = useState(
    window.innerWidth >= 640 && window.innerWidth < 768
  );
  const [isMd, setIsMd] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1024
  );
  const [isLg, setIsLg] = useState(
    window.innerWidth >= 1024 && window.innerWidth < 1280
  );
  const [isXl, setIsXl] = useState(
    window.innerWidth >= 1280 && window.innerWidth < 1536
  );
  const [is2xl, setIs2xl] = useState(window.innerWidth >= 1536);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsXsm(w >= 410 && w < 640);
      setIsSm(w >= 640 && w < 768);
      setIsMd(w >= 768 && w < 1024);
      setIsLg(w >= 1024 && w < 1280);
      setIsXl(w >= 1280 && w < 1536);
      setIs2xl(w >= 1536);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      style={{
        paddingTop: "96px",
        paddingBottom: "96px",
      }}
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <AnimatedTitle
          className="text-3xl font-semibold mb-10 mx-auto text-center w-3/4 lg:w-7/12"
          style={{ color: "var(--color-primary)" }}
        >
          Building Your Data Platform From Your Phone
        </AnimatedTitle>

        <AnimatedBox>
          <div
            className="flex flex-col lg:flex-row items-center lg:items-star rounded-lg overflow-hidden"
            style={{
              backgroundImage: "url(/building2.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="w-full lg:w-2/5 px-6 flex flex-col items-center md:items-start text-center md:text-left py-16 lg:py-0">
              <h3
                className="text-2xl xl:text-3xl 2xl:text-5xl font-semibold text-gray-800 mb-4"
                style={{ width: "90%", color: "#A2F4EC" }}
              >
                Building Your Data Platform From Your Phone
              </h3>
              <p
                className="mb-6 text-white"
                style={{
                  fontSize: isXl ? "18px" : is2xl ? "22px" : "16px",
                  width: "88%",
                }}
              >
                DATAGENX is the first AI-powered platform that lets you monitor,
                manage, and even launch parts of your data platform directly
                from your mobile device.
              </p>
              <Button
                content={"Coming Soon"}
                style={{ cursor: "not-allowed" }}
              />

              <div className="flex gap-4 mt-6 flex-col sm:flex-row md:flex-col lg:flex-row">
                {data.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      width: "150px",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      padding: "7px 15px 7px 10px",
                      borderRadius: "12px",
                      gap: "10px",
                      position: "relative",
                    }}
                  >
                    <img src={item.img} alt="mobile" />
                    <span
                      style={{
                        color: "#4B4B4B",
                        fontSize: "11px",
                        fontWeight: "600",
                      }}
                    >
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="w-full lg:w-3/5"
              style={{
                backgroundImage: "url(/building3.png)",
                backgroundSize: "cover",
                minHeight: isXsm
                  ? "400px"
                  : isSm
                  ? "460px"
                  : isMd
                  ? "550px"
                  : isLg
                  ? "530px"
                  : isXl
                  ? "530px"
                  : is2xl
                  ? "650px"
                  : "280px",
              }}
            ></div>
          </div>
        </AnimatedBox>
      </div>
    </section>
  );
}

export default BuildingSection;
